import storage from '@/utils/Storage'
import { DEFAULT_REDIRECT_URL, normalizeRedirectURL } from '@/utils/redirectURL'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login/app-auth/complete')({
	beforeLoad: () => {
		document.title = `登录中 - 即刻`

		const hashParams = new URLSearchParams(window.location.hash.slice(1))
		const accessToken = hashParams.get('accessToken')
		const deviceId = hashParams.get('deviceId')
		const redirectURL = normalizeRedirectURL(hashParams.get('redirectURL') ?? DEFAULT_REDIRECT_URL)

		window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`)

		if (!accessToken || !deviceId) {
			window.location.replace(`/login?redirectURL=${encodeURIComponent(redirectURL)}`)
			return
		}

		storage.auth.token = accessToken
		storage.auth.deviceId = deviceId
		window.location.replace(redirectURL)
	},
})
